import { Icon, IconProps } from '@chakra-ui/react';
import { MonitorCheck } from 'lucide-react';

export const MonitorCheckIcon = (props: IconProps) => {
  return <Icon as={MonitorCheck} height="24px" width="24px" {...props} />;
};
